import { Component, Input, OnInit, ViewChild, EventEmitter, Output, ViewEncapsulation } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
    selector: 'confirm-small',
    templateUrl: './confirm-small.component.html',
    styleUrls: ['./confirm-small.component.scss']
})
export class ConfirmSmallComponent implements OnInit {
    @Input() type: string = 'button';
    @Input() buttonType: string = 'string';
    @Input() tooltip: string = '';
    @Input() icon: string = 'done';
    @Input() color: string = 'primary';
    @Input() buttonTxt: string = 'Confirm';
    @Input() popoverMsg: string = '';
    @Input() popoverConfirmText: string = 'Confirm';
    @Input() popoverConfirmColor: string = 'primary';
    @Input() popoverCancelText: string = 'Cancel';
    @Input() popoverCancelColor: string = 'accent';
    @Input() disabled: boolean = false;
    @Input() class: string = '';
    @Output() onConfirm: EventEmitter<any> = new EventEmitter();
    @ViewChild('confirmElement') confirmElement!: MatButton;
    isPopupVisible = false;
    dataBsPopover: string = 'focus';


    constructor() {}

    ngOnInit(): void {}

    confirm() {
        this.onConfirm.emit();
        this.isPopupVisible = false;
    }

    openMenu() {

         this.isPopupVisible = !this.isPopupVisible;
         console.log("isPopupVisible:")
         console.log(this.isPopupVisible)
        this.confirmElement.focus();
    }

    closeMenu() {
        this.isPopupVisible = false;
    }
}
